import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPageCheck: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="page-check, signed, document"><path d="M9.75 21.25H4.75V2.75H19.25V10.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M13.25 19.0832L15.3929 21.25L20.75 14.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconPageCheck;
